export class Induction {
	set_tasks_id                : number;
        set_tasks_title             : string;
        set_tasks_task_type_id      : number;
        set_description             : string;
        set_date                    : string;
        set_role                    : number;
        set_subrole_id              : number;
        set_task_type_name          : string;
        record_date_finish          : string;
        filename_path               : string;
        record_filename             : string;
        record_status               : number;
        record_id                   : number;
        set_id                      : number;
        user_id                     : number;
        record_expiry               : string;
        date_started                : string;
        time_started                : string;
        date_finish               : string;
        time_finish               : string;
        score_status                : number;
                                
}
